import React from 'react';

const Loading = () => (
  <div className="bs4 d-flex justify-content-center align-items-center my-5">
    <span>Loading…</span>
  </div>
);

export default Loading;
